// extracted by mini-css-extract-plugin
module.exports = {"modal":"Modal_modal__vdLdL"};